import { useCurrentRefinements, useInstantSearch } from 'react-instantsearch';

import { useConfigContext } from '@sorare/core/src/contexts/config';
import {
  APPEARANCES_15_MAX,
  APPEARANCES_5_MAX,
  APPEARANCES_MIN,
  CARD_LEVEL_MIN,
} from '@sorare/core/src/lib/cards';
import { FILTERS, TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';

export const useRelevantRefinements = () => {
  const {
    so5: { cardMaxGrade },
  } = useConfigContext();
  const { items } = useCurrentRefinements();
  const {
    indexUiState: { menu },
  } = useInstantSearch();

  const menuAttributes = (menu && Object.keys(menu)) || [];

  return items.filter(item => {
    if (item.attribute === FILTERS.cardLevel.attribute) {
      return (
        item.refinements.length !== 2 ||
        item.refinements[0].value !== CARD_LEVEL_MIN ||
        item.refinements[1].value !== cardMaxGrade
      );
    }
    if (item.attribute === FILTERS.lastFiveAppearances.attribute) {
      return (
        item.refinements.length !== 2 ||
        item.refinements[0].value !== APPEARANCES_MIN ||
        item.refinements[1].value !== APPEARANCES_5_MAX
      );
    }
    if (item.attribute === FILTERS.lastFifteenAppearances.attribute) {
      return (
        item.refinements.length !== 2 ||
        item.refinements[0].value !== APPEARANCES_MIN ||
        item.refinements[1].value !== APPEARANCES_15_MAX
      );
    }

    if (menuAttributes.includes(item.attribute)) {
      return false;
    }

    return item.attribute !== TOGGLE_FILTERS.inSeasonFilter.attribute;
  });
};
